<template>
    <v-card rounded="lg" class="rounded-lg pa-3 pt-0" v-if="campData.MSG_DELIVERED">
        <v-card-title class="px-3 pb-4 pt-6">
            <div class="sentMsgs">
                <v-icon color="primary" class="iconSent mt-1">$campaign_d</v-icon>
                <h3 class="primary--text d-flex justify-center align-center" style="height:30px;">
                    {{ campData.total }} 
                    <v-chip dense label small class="px-2 ml-1 mr-1" color="success" v-if="campData.total_external">+{{ campData.total_external }}</v-chip>
                    messages envoyés
                </h3>
            </div>
        </v-card-title>

        <v-card-text class="statMsg">
            <div class="deliveredMsg" v-if="campData.MSG_DELIVERED.total">
                <h5 class="icon-title mb-2 mt-2" @click="getStats('MSG_DELIVERED')"><span>Messages délivrés <v-icon small color="primary" class="ml-2 iconEye">$eye_d</v-icon></span> <span>{{ campData.MSG_DELIVERED.total.count }}<span class="success--text ml-1" v-if="campData.MSG_DELIVERED.total.count_external && campData.MSG_DELIVERED.total.count_external > 0">+{{ campData.MSG_DELIVERED.total.count_external }}</span></span></h5>
                <div>
                    <div class="mb-6 detail" @click="getStats(index)" v-for="(detail, index) in campData.MSG_DELIVERED.details">
                        <div class="d-flex justify-space-between mb-1 label"><span>{{ $t(index) }} <v-icon small color="primary" class="ml-2 mb-0 iconEye">$eye_d</v-icon></span><span>{{ detail.count }} <span class="success--text" v-if="detail.count_external && detail.count_external > 0">+{{ detail.count_external }}</span></span></div>
                        <v-progress-linear v-if="detail.count_external" rounded class="grey lighten-2" background-color="success" :buffer-value="getPercent(detail.count_external + detail.count, (campData.total + campData.total_external))" :value="getPercent(detail.count, (campData.total + campData.total_external))"></v-progress-linear>
                        <v-progress-linear rounded v-else :value="getPercent(detail.count, campData.total)"></v-progress-linear>
                    </div>
                </div>
            </div>

            <div class="notDeliveredMsg mt-8" v-if="campData.MSG_NOTDELIVERED.total">
                <h5 class="icon-title mb-2" @click="getStats('MSG_NOTDELIVERED')"><span>Non délivrés <v-icon small color="primary" class="ml-2 iconEye">$eye_d</v-icon></span> <span>{{ campData.MSG_NOTDELIVERED.total.count }}<span class="success--text ml-1" v-if="campData.MSG_NOTDELIVERED.total.count_external && campData.MSG_NOTDELIVERED.total.count_external > 0">+{{ campData.MSG_NOTDELIVERED.total.count_external }}</span></span></h5>
                <div>
                    <div class="mb-6 detail" @click="getStats(index)" v-for="(detail, index) in campData.MSG_NOTDELIVERED.details">
                        <div class="d-flex justify-space-between mb-1 label"><span>{{ $t(index) }}<v-icon small color="primary" class="ml-2 iconEye">$eye_d</v-icon></span><span>{{ detail.count }} <span class="success--text" v-if="detail.count_external && detail.count_external > 0">+{{ detail.count_external }}</span></span></div>
                        <v-progress-linear v-if="detail.count_external" rounded class="grey lighten-2" background-color="success" :buffer-value="getPercent(detail.count_external + detail.count, (campData.MSG_NOTDELIVERED.total.count + campData.MSG_NOTDELIVERED.total.count_external))" :value="getPercent(detail.count, (campData.MSG_NOTDELIVERED.total.count + campData.MSG_NOTDELIVERED.total.count_external))"></v-progress-linear>
                        <v-progress-linear v-else rounded :value="getPercent(detail.count, campData.MSG_NOTDELIVERED.total.count)"></v-progress-linear>
                    </div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService'
export default {
    name: "campaignStat",
    props:['campaign'],
    data() {
        return {
            campData: {
            }
        }
    },
    created() {
        if(!this.campData.total && this.$route.params.id) {
            GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getCampaignStats').then((response) => {
                this.campData = response.data.data;
            });
        }
    },
    mounted() {
        if(!this.campData.total && this.$route.params.id) {
            GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getCampaignStats').then((response) => {
                this.campData = response.data.data;
            });
        }
    },
    methods: {
        getStats(label){
            let item = {}
            item.label = label;
            this.$emit('openStats', item);
        },
        getPercent(value, total){
            return value*100/total
        }
    },
}
</script>

<style lang="scss">
    .statMsg {
        .icon-title {
            align-items:center;
            height:26px;
            cursor:pointer;
            .iconEye {
                display:none;
            }
            &:hover {
                .iconEye {
                    display: inline;
                }
            }
        }
        .detail {
            .label {
                color:#000;
                font-size:14px;
                cursor:pointer;
                .iconEye {
                    display:none;
                }
            }   
            &:hover {
                .iconEye {
                    display: inline;
                }
            }
        }
        
    }
    .sentMsgs {
        position:relative;
        padding:15px 10px;
        width:100%;
        font-weight:bold;
        background-color: #ecebf8;
        border-radius:10px;
        text-align:center;
        .iconSent {
            position:absolute;
            left:20px;
            top:12px;
        }
    }
</style>